import type { IProductRepository } from '@/core/domain/repositories/IProductRepository';

export class GetBrandProductsUseCase {
  constructor(private readonly repository: Pick<IProductRepository, 'findByBrand'>) {}

  execute(slug: string, page: number) {
    return this.repository.findByBrand(slug, { page, limit: 20 });
  }
}
